/**************************************************
 * Nombre:       Home_Programas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import TextoTitulo from "./SucComponentes/TextoTitulo";
import Tarjeta_Profundizaciones from "../../Tarjetas/Tarjeta_Profundizaciones";
import tecnicos from '../../../Recursos/Tipos/tecnicos.png'
import diplomados from '../../../Recursos/Tipos/diplomados.png'
import comple from '../../../Recursos/Tipos/comple.png'
import Zoom from 'react-reveal/Zoom';

const Home_Programas = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 11}}>


                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <TextoTitulo texto={'Programas'}
                                     titulo={'Técnicos, profundizaciones y convenios universitarios'}/>
                    </Grid>


                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{mt: sCell ? 12 : 14}}
                        spacing={4}
                    >

                        {items.map((item, index) => (
                            <Grid key={index+'26'} container size={{xs: 12, sm: 12, md: 4}} sx={{justifyContent: 'flex-start'}}>
                                <Zoom>
                                    <Tarjeta_Profundizaciones item={item}/>
                                </Zoom>
                            </Grid>
                        ))}

                    </Grid>

                </Grid>


            </Grid>


        </Grid>
    )

}
export default Home_Programas

const items = [
    {
        nombre: 'Técnicos Laborales',
        descripcion: 'Programas prácticos diseñados para una empleabilidad rápida en sectores clave como tecnología, administración, salud e industria',
        img: tecnicos
    },
    {
        nombre: 'Diplomados de Profundización',
        descripcion: 'Opciones de grado que permiten especializar los conocimientos técnicos antes de salir al mundo laboral',
        img: diplomados
    },
    {
        nombre: 'Formación Complementaria',
        descripcion: 'Materias transversales integradas en los currículos, como Inglés (niveles I, II y III auditivo), Emprendimiento y Salud Ocupacional',
        img: comple
    },
]